import { standardDrawing } from '@moleculeone/draw';
import { DrawnMol, Mol } from '@moleculeone/types';

import { ReversedSubstratesMap } from './reverseMapping';

type ReactionHighlight = number[][];

export type ReactionHighlights = ReactionHighlight[];

export type ProductDrawer = (mol: Mol) => DrawnMol;

export type SubstrateDrawer = (mol: Mol, substrateIdx: number) => DrawnMol;

export type MolDrawers = {
  drawProduct: ProductDrawer;
  drawSubstrate: SubstrateDrawer;
};

export function getPlainMolDrawers(
  mapToSubstrates: ReversedSubstratesMap,
  highlights: ReactionHighlights = []
): MolDrawers {
  const drawProduct = (mol: Mol): DrawnMol => standardDrawing(mol) as DrawnMol;

  // Substrate drawing function
  const drawSubstrate = (mol: Mol, substrateIdx: number): DrawnMol => {
    const selected = highlights
      .flatMap(([_highlightName, mapIds]) => mapIds)
      .map(cls => mapToSubstrates[cls])
      .filter(x => x != null)
      .filter(([classSubstrateIdx, _atomIndex]) => classSubstrateIdx === substrateIdx)
      .map(([_clsIndex, atomIndex]) => atomIndex);

    return standardDrawing(mol, selected) as DrawnMol;
  };

  return {
    drawProduct,
    drawSubstrate,
  };
}
